<template>
  <div>
    <div class="page-form-header small-header">
      <h1>Welcome!</h1>
    </div>
    <div class="description">
      Set a password you can easily <br />
      remember to log in next time
    </div>
      <form-input-password v-model="profile.password"
                           :validator="$v.profile.password"
                           label="New Password">
      </form-input-password>

      <form-input-password v-model="profile.confirmPassword"
                           :validator="$v.profile.confirmPassword"
                           label="Confirm New Password">
      </form-input-password>
    <div class="form-group">
      For your security, please make sure your password is:
      <ul>
        <li>at least <b>12 characters</b></li>
        <li>at least <b>1 UPPER CASE LETTER</b></li>
        <li>at least <b>1 lower case letter</b></li>
        <li>at least <b>1 number 0-9</b></li>
        <li>at least <b>1 special character !@#$%^&*()-+</b></li>
      </ul>
      If you use an Apple device, the suggested password is a perfect option!
    </div>
  </div>
</template>

<script>
  import { required, sameAs } from "vuelidate/lib/validators";
  import { password } from "utils/custom-validators";
  import formMixin from "mixins/form-mixin";

  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('profile');

  export default {
    mixins: [formMixin],

    data() {
      return {
      };
    },

    validations: {
      profile: {
        password: {
          required,
          password
        },
        confirmPassword: {
          required,
          confirmPassword: sameAs("password")
        }
      }
    },

    computed: {
      ...mapState(["profile"])
    },
  };
</script>